<template>
  <general-data/>
</template>

<script>
import userProfile from '../../../components/user-profile/user-profile'
import generalData from '../../../components/user-profile/general-data'
export default {
  name: 'GeneralDataView',
  components: {
    userProfile, generalData
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/user-profile/general-data.view.vue